import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAdminLogin } from "../../Functions/isLogin";

const AdminPrivateRoutes = () => {
  return isAdminLogin() ? <Outlet /> : <Navigate to="/" />;
};

export default AdminPrivateRoutes;
